/**
 * @type {<T>(stylesheet: T) => ((...classNames: string[]) => string)}
 */
export function useStyle(stylesheet) {
  return function (...classNames) {
    const classList = classNames.join(" ").split(" ");

    return classList
      .reduce(
        (finalClassName, className) =>
          `${finalClassName} ${stylesheet[className]}`,
        ""
      )
      .trim();
  };
}

/**
 * @type {<T>(props: T) => ((className: string,...modifiers: (keyof T)[]) => string)}
 */
export function cssModifiers(props) {
  return function (className, ...modifiers) {
    let finalClassName = className;

    modifiers.forEach((modifier) => {
      if (props[modifier]) finalClassName += ` ${className}--${modifier}`;
    });

    return finalClassName;
  };
}



// WEBPACK FOOTER //
// ./src/rifa/utils/sass.js